import { Callout, Card, LabelledList, Stack, Text, TitleGroup } from '@ekhodealer/ekho-common/rev';

import type { LabelledListItem } from '@ekhodealer/ekho-common/rev';

import { onboardingContent, OnboardingPage } from './content';

export function HowEkhoWorksPage() {
	const pageContent = onboardingContent[OnboardingPage.HowEkhoWorks];

	const howEkhoWorksSteps: LabelledListItem[] = [
		{
			content: (
				<Stack itemsSpacing='4'>
					<Text size='body' weight='bold'>
						Connect your inventory (zero IT lift)
					</Text>
					<Text size='bodySmall' color='secondary'>
						Link your DMS in minutes. Your units automatically populate your Ekho
						inventory feed with instant online checkout or lead capture. MAP pricing and
						compliance rules are enforced automatically.
					</Text>
				</Stack>
			),
		},
		{
			content: (
				<Stack itemsSpacing='4'>
					<Text size='body' weight='bold'>
						Configure your store (your rules, your margins)
					</Text>
					<Text size='bodySmall' color='secondary'>
						Choose which units allow full online checkout vs. leads only. Set your PDI,
						doc, and delivery fees. White-label your checkout with your logos, colors,
						and font.
					</Text>
				</Stack>
			),
		},
		{
			content: (
				<Stack itemsSpacing='4'>
					<Text size='body' weight='bold'>
						Sell 24/7 nationwide (Ekho handles the heavy lifting)
					</Text>
					<Text size='bodySmall' color='secondary'>
						Shoppers complete purchases online — financing, tax, and DMV work — without
						the overhead. Leads and sales feed straight back to your DMS for smooth
						fulfillment.
					</Text>
				</Stack>
			),
		},
	];

	return (
		<Stack itemsSpacing='24'>
			<TitleGroup
				title={pageContent.pageTitle}
				description={pageContent.subtitle}
				level='page'
				variant='centered'
				maxWidth='640px'
			/>

			{pageContent.contentCards && (
				<Callout
					variant='information'
					appearance='filled'
					title={pageContent.contentCards[0].title}
					message={pageContent.contentCards[0].subtitle}
				/>
			)}

			<Card>
				<LabelledList items={howEkhoWorksSteps} variant='numbered' />
			</Card>
		</Stack>
	);
}
